// ─────────────────────────────────────────────
// Helpers
// ─────────────────────────────────────────────
export const buildImageUrl = (raw?: string | null): string | null => {
  if (!raw) return null;
  if (raw.startsWith('http') || raw.startsWith('/')) return raw;
  return `/media/${raw}`;
};

export const formatAreaCell = (min?: number | null, max?: number | null): string => {
  if (min && max && min !== max) return `${min}~${max}㎡`;
  if (min) return `${min}㎡`;
  if (max) return `${max}㎡`;
  return '';
};

export const formatPyeong = (area?: number | null): string => {
  if (!area) return '';
  const py = Math.round(area * 0.3025);
  return ` (${py}평형)`;
};

export const extractEyebrow = (address?: string | null): string => {
  if (!address) return '';
  const cleaned = address.replace(/^대구광역시\s*/, '대구 ').replace(/^경상북도\s*/, '경북 ');
  return cleaned.split(/\s+/).slice(0, 3).join(' · ');
};

// 운영 backend property_seo_view와 동일한 SEO 추출 패턴
// (서버 측 메타 주입 결과와 클라이언트 Helmet 결과를 일관되게 유지)
export const SEO_CITY_PATTERN = /(서울|부산|대구|인천|광주|대전|울산|세종|경기|강원|충북|충남|전북|전남|경북|경남|제주)/;
export const SEO_GU_PATTERN = /([가-힣]+[구군])\s/;
const SEO_DONG_PAREN = /\(([가-힣]+동)\)/;
const SEO_DONG_SPACE = /([가-힣]+동)\s/;
const SEO_DONG_END = /([가-힣]+동)$/;

export const extractSeoDong = (address: string): string => {
  return (
    address.match(SEO_DONG_PAREN)?.[1] ||
    address.match(SEO_DONG_SPACE)?.[1] ||
    address.match(SEO_DONG_END)?.[1] ||
    ''
  );
};

export const shortenAddress = (address: string): string =>
  address.replace(/광역시/g, '').replace(/특별시/g, '').replace(/\s+/g, ' ').trim();

// 한글 음절 마지막 글자의 받침 유무로 주제 조사 결정 (은/는)
export const getTopicJosa = (text: string): '은' | '는' => {
  const last = text.slice(-1);
  if (!last) return '는';
  const code = last.charCodeAt(0) - 0xAC00;
  if (code < 0 || code >= 11172) return '는';
  return code % 28 > 0 ? '은' : '는';
};
